export var COUNTRY_SOURCE = /*#__PURE__*/function (COUNTRY_SOURCE) {
  COUNTRY_SOURCE["DEFAULT_COUNTRY"] = "default_country";
  COUNTRY_SOURCE["EXISTING_COUNTRY"] = "existing_country";
  COUNTRY_SOURCE["USER_SELECTED"] = "user_selected";
  return COUNTRY_SOURCE;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/constants/BillingCountryConstants.js
// module id = 1487
// module chunks = 11